import { useSyncExternalStore } from 'react'

import type { Theme } from '@/contexts/theme.context'

// Lets a caller (such as chart download) render the app in a theme other than the user's choice.
let themeOverride: Theme | null = null
const listeners = new Set<() => void>()

const subscribe = (listener: () => void) => {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}

const getSnapshot = () => themeOverride

/** Renders the app in `theme` until called with `null`. */
export const setThemeOverride = (theme: Theme | null) => {
  themeOverride = theme
  listeners.forEach((listener) => listener())
}

/** The forced theme, or `null` when the user's own theme applies. */
export const useThemeOverride = (): Theme | null => useSyncExternalStore(subscribe, getSnapshot)
